import { render, staticRenderFns } from "./tinymce-image.vue?vue&type=template&id=3db2d0cc"
import script from "./tinymce-image.vue?vue&type=script&lang=js"
export * from "./tinymce-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports